import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  DEFAULT_LOCALE,
  normalizeLocale,
  translationResources,
} from '@nest-react/lib';

void i18n.use(initReactI18next).init({
  resources: translationResources,
  lng: normalizeLocale(
    typeof navigator === 'undefined' ? DEFAULT_LOCALE : navigator.language
  ),
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'common',
  ns: Object.keys(translationResources.en),
  interpolation: { escapeValue: false },
  returnNull: false,
});

export { i18n };
